if(typeof CANNON === 'undefined') {var e = new Error("Cannot find module 'CANNON'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = CANNON;